import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cities: [],
    symptomsContactsInfo: {
      name: '',
      contact: '',
      city: ''
    },
    symptomsLeft: [],
    symptomsRight: [],
    users: 0,
    statistic: [],
    thanksPopup: false
  },
  mutations: {
    setCities(state, data) {
      state.cities = data
    },
    setSymptoms(state, data) {
      state.symptomsRight = [];
      state.symptomsLeft = [];
      for (let key in data) {
        if (key == 0 || key%2 == 0) {
          state.symptomsRight.push(data[key]);
        } else {
          state.symptomsLeft.push(data[key]);
        }
      }
    },
    setUsers(state, value) {
      state.users = value;
    },
    setStatistic(state, data) {
      state.statistic = data;
    },
    setThanksPopup(state, value) {
      state.thanksPopup = value;
    },
    clearSymptomsContactsInfo(state) {
      state.symptomsContactsInfo = {
        name: '',
        contact: '',
        city: ''
      }
    }
  },
  actions: {
    async getCities(context) {
      try {
        let response = await axios.get('https://api.hculture.ru/v1/landing/cities');
        context.commit('setCities', response.data.result);
      } catch (error) {
        console.log(error);
      }
    },
    async getSymptoms(context) {
      try {
        let response = await axios.get('https://api.hculture.ru/v1/landing/epidemic/symptoms');
        context.commit('setSymptoms', response.data.result);
      } catch (error) {
        console.log(error);
      }
    },
    async getUsers(context) {
      try {
        let response = await axios.get('https://api.hculture.ru/v1/landing/epidemic/users/count');
        context.commit('setUsers', response.data.result);
      } catch (error) {
        console.log(error);
      }
    }, 
    async getStatistic(context) {
      try {
        let response = await axios.get('https://api.hculture.ru/v1/landing/epidemic/statistics');
        context.commit('setStatistic', response.data);
      } catch (error) {
        console.log(error);
      }
    },
    async newUser(context, data) {
      try {
        await axios.post('https://api.hculture.ru/v1/landing/epidemic/users', data);
        context.commit('setThanksPopup', true);
        context.commit('clearSymptomsContactsInfo');
      } catch (error) {
        console.log(error);
      }
    }, 
    async sendFeedback(context, data) { // eslint-disable-line no-unused-vars
      try {
        await axios.post('https://api.hculture.ru/v1/landing/feedback', data);
      } catch (error) {
        console.log(error);
      }
    }, 
  },
  modules: {
  }
})
